import Reply from '../../../assets/reply.svg';

const ReplyIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return <Reply {...props} />;
};

export default ReplyIcon;
